let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b5ANU")).then(() => parcelRequire('9JT0Q'));